import { z } from 'zod';

import { idSchema, isoDateSchema, slugSchema } from './common.schema';

export const planSchema = z.enum(['free', 'starter', 'business', 'enterprise']);
export type Plan = z.infer<typeof planSchema>;

export const workspaceSchema = z.object({
  id: idSchema,
  name: z.string().min(1).max(200),
  slug: slugSchema,
  plan: planSchema,
  timezone: z.string().min(1).max(64),
  locale: z.string().min(2).max(8),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});
export type Workspace = z.infer<typeof workspaceSchema>;

export const createWorkspaceSchema = z.object({
  name: z.string().min(1).max(200),
  slug: slugSchema,
  timezone: z.string().min(1).max(64).default('Europe/Moscow'),
  locale: z.string().min(2).max(8).default('ru'),
});

export const updateWorkspaceSchema = createWorkspaceSchema.partial();

export const onboardingStateSchema = z.object({
  current_step: z.number().int().min(0).optional(),
  completed_steps: z.array(z.string()).optional(),
  completed: z.boolean().optional(),
  completed_at: isoDateSchema.optional(),
});
